export default function LoadingPage({
  message = "Memuat...",
  showSkeleton = true,
}) {
  return (
    <div className="flex flex-col items-center justify-center w-full h-[80vh]">
      {/* Loading bulat */}
      <div className="w-16 h-16 rounded-full border-4 border-t-amber-700 border-gray-200 animate-spin" />

      {/* Pesan teks */}
      <p className="mt-4 text-gray-600 font-medium">{message}</p>

      {/* Skeleton opsional */}
      {showSkeleton && (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-3xl">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="p-4 bg-gray-100 rounded-lg animate-pulse">
              <div className="h-6 bg-gray-200 rounded w-2/3 mb-3" />
              <div className="h-4 bg-gray-200 rounded w-full mb-2" />
              <div className="h-4 bg-gray-200 rounded w-5/6" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
